// tickets
export const ticketAlmostExpiredMinutes = 59
